import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RequireStringMatchDirective} from './require-string-match.directive';


@NgModule({
    declarations: [RequireStringMatchDirective],
    exports: [
        RequireStringMatchDirective
    ],
    imports: [
        CommonModule
    ]
})
export class RequireStringMatchModule { }
